import React, { useRef, useState } from "react";
import { testIdProps } from "../../../../../utils/testIdProps";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import Styles from "../../Shared/sharedStyles.module.scss";
import InputField from "../../Shared/inputField/inputField";
import Button, {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";
import {
  primaryButtonStyleOkyc,
  primaryButtonHoverStyleOkyc,
} from "../../../../../Shared/buttonStyles";
import { COMPRESSED } from "../../../../../Shared/buttonSize";
import { validOtpNumber, validEmailOtp } from "../../../../../utils/validation";

function EmailServicePopup({ handleResponse, getOtp, name }: any) {
  const errorObject = {
    emailError: false,
    fetchError: false,
    otpError: false,
    consentError: false,
    nameError: false,
    nameEmptyError: false,
    emailEmptyError: false,
  };

  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [isOtpTriggered, setIsOtpTriggered] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingForOtp, setLoadingForOtp] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [buttonText, setButtonText] = useState("Send Otp");
  const emailVerificationRef = useRef<any>("");
  const nameRef = useRef<any>("");
  const otpRef = useRef<any>("");

  function isValidName(name: any) {
    const pattern = /[^a-zA-Z\s]/g;
    if (pattern.test(name)) {
      return false;
    }
    if (!name.replace(/\s/g, "").length) {
      return false;
    }
    if (name.length < 2) {
      return false;
    }
    return true;
  }

  async function checkemail() {
    try {
      const email = emailVerificationRef.current.value.toLowerCase().trim();
      const name = nameRef.current.value;

      if (name.length === 0) {
        setError(() => ({
          ...error,
          nameEmptyError: true,
        }));
        resetError();
        return false;
      }
      if (!isValidName(name)) {
        setError(() => ({
          ...error,
          nameError: true,
        }));
        resetError();
        return false;
      }
      if (email.length === 0) {
        setError(() => ({
          ...error,
          emailEmptyError: true,
        }));
        resetError();
        return false;
      }
      if (!validEmailOtp(email, false)) {
        setError(() => ({
          ...error,
          emailError: true,
        }));
        resetError();
        return false;
      }

      setLoadingForOtp(true);
      const res = await getOtp(email, setLoadingForOtp, name);
      if (res.result.is_otp_sent) {
        setIsOtpTriggered(true);
        setIsOtpSent(true);
        setButtonText("Resend Otp");
        setTimeout(() => setIsOtpSent(false), 60000);
      }
    } catch (e) {
      setError(() => ({
        ...error,
        fetchError: true,
      }));
      resetError();
    }
  }

  function isValid() {
    if (
      validEmailOtp(emailVerificationRef.current.value.trim(), false) &&
      isValidName(nameRef.current.value.trim()) &&
      validOtpNumber(otpRef.current.value.trim())
    )
      return setIsDisabled(false);
    return setIsDisabled(true);
  }

  function resetError() {
    setTimeout(() => setError({ ...errorObject }), 3000);
  }

  function setOtpStatus() {
    if (isOtpTriggered) setIsOtpTriggered(false);
    setIsDisabled(true);
  }

  function handleCheck() {
    const otp = otpRef.current.value;

    if (!validOtpNumber(otp)) {
      setError(() => ({
        ...error,
        otpError: true,
      }));
      return false;
    } else if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }
    const consent = isChecked === true ? "Y" : "N";
    setLoading(true);
    handleResponse({ otp, consent }, setLoading);
  }
  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4 ">
            <div className="d-flex align-items-center">
              <div className="d-flex flex-column">
                <div className="d-flex flex-column mb-4 ">
                  <div style={{ width: "66%" }}>
                    <label className={`${Styles.label} flex-grow-1`}>
                      Name:
                    </label>
                    <InputField
                      id="id-input-voter"
                      text="lowerCase"
                      onChange={setOtpStatus}
                      inputRef={nameRef}
                      isError={error.nameError}
                      purpose="forVoter"
                    />
                    {error.nameEmptyError ? (
                      <ErrorMessage> Name should not be blank </ErrorMessage>
                    ) : error.nameError ? (
                      <ErrorMessage>Name is not valid</ErrorMessage>
                    ) : null}
                  </div>
                </div>

                <label className={`${Styles.label} flex-grow-1`}>Email</label>
                <div className="d-flex">
                  <div className={Styles.inputContainer}>
                    <InputField
                      id="id-input-voter"
                      text="lowerCase"
                      onChange={setOtpStatus}
                      inputRef={emailVerificationRef}
                      isError={error.emailError}
                      purpose="forVoter"
                    />
                    {error.emailEmptyError ? (
                      <ErrorMessage> Email should not be blank </ErrorMessage>
                    ) : error.emailError ? (
                      <ErrorMessage> Please enter a valid Email</ErrorMessage>
                    ) : null}
                  </div>

                  <div className={Styles.buttonContainer}>
                    <Button
                      id="id-input-submit-aadhaar-number"
                      hoveredStyle={primaryButtonHoverStyleOkyc}
                      disabled={isOtpSent}
                      size={COMPRESSED}
                      isLoading={loadingForOtp}
                      style={primaryButtonStyleOkyc}
                      onClick={() => {
                        checkemail();
                      }}
                    >
                      {buttonText}
                    </Button>
                  </div>
                </div>
                {error.fetchError && (
                  <div>
                    <ErrorMessage>
                      Could not fetch info, please try later.
                    </ErrorMessage>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="d-flex flex-column mb-4 ">
            {isOtpTriggered && (
              <div className="d-flex flex-column">
                <label className={`${Styles.label} flex-grow-1`}>OTP</label>
                <InputField
                  id="id-input-otp"
                  onChange={isValid}
                  maxLength={6}
                  inputRef={otpRef}
                  isError={error.otpError}
                  purpose="forOtp"
                />
                {error.otpError && (
                  <ErrorMessage>Please enter a valid OTP</ErrorMessage>
                )}
              </div>
            )}
          </div>
          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input {...testIdProps("consent-checkbox-email-verification-api")}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => setIsChecked(e.target.checked)}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id="id-submit-button-okyc"
              hoverStyle={{ ...buttonStyles.primary.hover }}
              disabled={isDisabled}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailServicePopup;
